var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "close_svg__a",
    width: "136.7%",
    height: "135.5%",
    x: "-18.3%",
    y: "-17.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 9,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 12,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    filter: "url(#close_svg__a)",
    transform: "translate(-421 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.77 28 1.23 1.23-6.77 6.77 6.77 6.77-1.23 1.23-6.77-6.77-6.77 6.77-1.23-1.23 6.769-6.77L425 29.23l1.23-1.23 6.77 6.769L439.77 28z"
  }))));
};
export default SvgClose;